import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { popupActions } from '../../store/popupStore';
import { Translate, withLocalize } from 'react-localize-redux';
import { windowActions } from '../../store/windowStore';
import PropTypes from 'prop-types';
import SearchTipWindow from './windows/searchTipWindow';

import './searchTip.scss';

class SearchTip extends React.Component {
    static propTypes = {
        windowId: PropTypes.string.isRequired,
        getSearchTipsModel: PropTypes.func.isRequired,
        parentPin: PropTypes.string,
        windowPin: PropTypes.string,
        className: PropTypes.string,
        style: PropTypes.object,
    };

    static defaultProps = {
        parentPin: 'left-bottom',
        windowPin: 'right-top',
        className: '',
        style: undefined
    };

    render() {
        return (
            <div className={`search-tip ${this.props.className}`} style={this.props.style}>
                <span id={`search-tip-window-opener`} onClick={this.onTooltipClick} className="print-hidden" style={{ cursor: "pointer" }}>
                    <FontAwesomeIcon icon="question-circle" /> <Translate id='SearchTips.Opener' />
                </span>
            </div>
        )
    }

    onTooltipClick = (e) => {
        window.innerWidth <= 768 ? this.openPopup() : this.openWindow(e);
    }

    openWindow = (e) => {
        this.props.openWindow(this.props.windowId, true, SearchTipWindow,
            this.props.getSearchTipsModel(), { element: e.currentTarget || e.target, parentPin: this.props.parentPin, windowPin: this.props.windowPin })
    }

    openPopup = () => {
        this.props.showPopup("searchTipPopup",
            {
                open: true,
                name: this.props.getSearchTipsModel().title || "",
                bodyHtml: this.props.getSearchTipsModel().bodyHtml || "",
                hideExtendedTitle: this.props.getSearchTipsModel().hideExtendedTitle || false,
                close: () => this.props.hidePopup()
            })
    }
}

export default withLocalize(connect(
    null,
    dispatch => bindActionCreators({ ...windowActions, ...popupActions }, dispatch)
)(SearchTip))